import React from 'react';
import { StarIcon } from 'lucide-react';
import { buyerReviews, type BuyerReview } from '../data/buyerReviews';

/**
 * Real buyer reviews with photos. Renders nothing until data/buyerReviews.ts
 * has at least one entry, so nothing fabricated is ever published.
 */
export function BuyerReviews() {
  if (buyerReviews.length === 0) return null;
  const [featured, ...rest] = buyerReviews;
  return <section aria-labelledby="buyer-reviews-heading" className="w-full bg-white text-ink" data-id="element-50" data-mp="2hhd4ato8rl8o">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-51" data-mp="2chh5r9ybcm0i">
        <div className="text-center" data-id="element-52" data-mp="28g5gj5jcq2su">
          <h2 id="buyer-reviews-heading" className="font-display text-3xl font-bold text-rink sm:text-5xl" data-id="element-53" data-mp="28h6sdc86ytbm">
            Coaches using it this season
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-ink-soft" data-id="element-54" data-mp="6nqzs9sjn4e0">
            Reviews from coaches who bought Figure Skating Class Ready, shared
            with their permission.
          </p>
        </div>

        <figure className="mt-10 grid items-center gap-6 rounded-3xl bg-glacier-soft p-6 sm:p-10 md:grid-cols-[220px_1fr] md:gap-10" data-id="element-55" data-mp="2757bptq1whn7">
          <img src={featured.photo} alt={`${featured.name}, ${featured.role}`} className="mx-auto h-40 w-40 rounded-full object-cover ring-4 ring-white shadow-card md:h-[220px] md:w-[220px]" data-id="element-56" data-mp="2c2pfl5p7o6oc" />
          <div data-id="element-57" data-mp="2qtpyy5rhxkz9">
            {featured.rating && <Stars rating={featured.rating} data-id="element-58" data-mp="2qurkx5a1vrvr" />}
            <blockquote className="mt-3 font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-59" data-mp="2uw32cnirt6sv">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-5" data-id="element-60" data-mp="2h2c3qa6kv7bx">
              <ReviewAuthor review={featured} data-id="element-61" data-mp="2m2g851u7obls" />
            </figcaption>
          </div>
        </figure>

        {rest.length > 0 && <ul className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-62" data-mp="39rj0p4qdvov2">
            {rest.map(review => <li key={`${review.name}-${review.location}`} className="flex flex-col rounded-card border border-ice-dark bg-white p-6 shadow-card" data-id="element-63" data-mp="3elnarwuy4d0d">
                {review.rating && <Stars rating={review.rating} data-id="element-64" data-mp="3jelhwipy9vls" />}
                <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-ink" data-id="element-65" data-mp="3egbly5weiqz4">
                  “{review.quote}”
                </blockquote>
                <div className="mt-5 flex items-center gap-3 border-t border-ice-dark pt-4" data-id="element-66" data-mp="35goo1u2vs3at">
                  <img src={review.photo} alt="" className="h-12 w-12 flex-none rounded-full object-cover" data-id="element-67" data-mp="35ihsd2q0ubfn" />
                  <ReviewAuthor review={review} data-id="element-68" data-mp="2vorbok04z5ai" />
                </div>
              </li>)}
          </ul>}
      </div>
    </section>;
}
function ReviewAuthor({
  review
}: {
  review: BuyerReview;
}) {
  return <div className="text-sm" data-id="element-69" data-mp="2hrchz32uobcq">
      <p className="font-semibold text-rink" data-id="element-70" data-mp="2hs5hpk3e60ld">{review.name}</p>
      <p className="text-ink-soft" data-id="element-71" data-mp="x9boewyhmqg7">
        {review.role} · {review.location}
      </p>
    </div>;
}
function Stars({
  rating
}: {
  rating: number;
}) {
  const value = Math.max(0, Math.min(5, Math.round(rating)));
  return <div className="flex gap-0.5" aria-label={`Rated ${value} out of 5`} data-id="element-72" data-mp="169ghs36ujobd">
      {Array.from({
      length: 5
    }, (_, i) => <StarIcon key={i} aria-hidden="true" className={`h-4 w-4 ${i < value ? 'fill-amber text-amber' : 'fill-ice-dark text-ice-dark'}`} data-id="element-73" data-mp="1b8b0z68q7ew0" />)}
    </div>;
}